import type { ButtonProps } from '@mui/material';
import MuiButton from '@mui/material/Button';

export function Button(props: ButtonProps) {
  return <MuiButton {...props} />;
}
